import { render, staticRenderFns } from "./Baccarat2.vue?vue&type=template&id=dca40dd6&scoped=true"
import script from "./Baccarat2.vue?vue&type=script&lang=js"
export * from "./Baccarat2.vue?vue&type=script&lang=js"
import style0 from "./Baccarat2.vue?vue&type=style&index=0&id=dca40dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca40dd6",
  null
  
)

export default component.exports